// extracted by mini-css-extract-plugin
export default {"root":"M1vpMbuGNFpHyurg_19c","heading":"oiulU2vI2fM0S6SoDrlA","box":"m0QWctvfOcjbbfMXm8Kf"};